import { RedirectInfoCardType } from "../../interfaces/redirectInfoCard/RedirectInfoCard.type";
import RedirectInfoCard from "./RedirectInfoCard";

export default function RedirectInfoCardContainer({
  items,
  scroll,
}: {
  items: RedirectInfoCardType[];
  scroll?: Boolean;
}) {
  return (
    <div className={`vas-w-100 vas-p-3`}>
      <div className={`vas-py-2`}>
        <div className={`vas-d-flex vas-gap-3`}>
          {items?.map((item: RedirectInfoCardType, idx: number) => {
            return <RedirectInfoCard item={item} key={idx} />;
          })}
        </div>
      </div>
    </div>
  );
}
